import {
  AuthenticationContextType,
  IBankIDIdentificationContext,
} from "@krea/shared/types/bankID";
import { PreferredLanguageEnum } from "@krea/shared/types/common";

import HttpService from "../../services/httpService";

const BASE_URL = "/api/v1/se/bank-id";

const AUTHENTICATE_URL = `${BASE_URL}/authenticate`;
const COLLECT_URL = `${BASE_URL}/collect`;
const CANCEL_URL = `${BASE_URL}/cancel`;

const instanceWithoutInterceptors =
  HttpService.createInstanceWithoutInterceptors();

export interface IAuthenticateResponse {
  orderRef: string;
  qrCode: string | null;
  autoStartToken: string | null;
}

export const authenticateViaBankID = async (ssn: string) => {
  return instanceWithoutInterceptors.post<IAuthenticateResponse>(
    AUTHENTICATE_URL,
    { ssn },
  );
};

interface ICollectParams {
  orderRef: string;
  authenticationContext?: AuthenticationContextType;
  identificationContext?: IBankIDIdentificationContext | null;
  extraData: {
    preferredLanguage: PreferredLanguageEnum | null;
    gaClientId: string | null;
  } | null;
}

interface ICollectResponse {
  orderRef: string;
  status: "pending" | "failed" | "complete";
  hintCode: string | null;
  qrCode: string;
  tokens: {
    accessToken: string;
    refreshToken: string;
  };
}

export const collectViaBankID = async ({
  orderRef,
  extraData,
  identificationContext,
  authenticationContext,
}: ICollectParams) => {
  return instanceWithoutInterceptors.post<ICollectResponse>(COLLECT_URL, {
    orderRef,
    extraData,
    identificationContext,
    authenticationContext,
  });
};

export const cancelViaBankID = async (orderRef: string) => {
  return instanceWithoutInterceptors.post<undefined>(CANCEL_URL, { orderRef });
};
